import { render, staticRenderFns } from "./ProductContentView.vue?vue&type=template&id=f21a3162&scoped=true&"
import script from "./ProductContentView.vue?vue&type=script&lang=js&"
export * from "./ProductContentView.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentView.vue?vue&type=style&index=0&id=f21a3162&prod&scoped=true&lang=css&"
import style1 from "./ProductContentView.vue?vue&type=style&index=1&id=f21a3162&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21a3162",
  null
  
)

export default component.exports